export default {
  path: "/user/cpa/proveedores",
  component: () => import("@/views/user/cpa/proveedores/ProveedoresLayout.vue"),
  meta: {
    requiresAuth: true,
    requiresCurso: true,
    requiresCpaDirectiva: true,
  },
  children: [
    {
      path: "",
      name: "proveedores-dashboard",
      component: () =>
        import("@/views/user/cpa/proveedores/SuppliersListView.vue"),
    },
    {
      path: ":supplierId",
      name: "proveedores-detalle",
      component: () =>
        import("@/views/user/cpa/proveedores/SupplierDetailView.vue"),
      props: true,
    },
  ],
};
